import { FC } from 'react';
import {
  EProfitBoostActions,
  TCheckProfitBoostPayload
} from 'newelements/_Betslip/managers/ProfitBoostManager/actions';
import { checkMultipleProfitBoostActionHandler } from 'newelements/_Betslip/managers/ProfitBoostManager/utils/checkProfitBoostActionHandler/multiple';
import { useEventbus } from 'newhooks/generic/useEventbus';

export const ProfitBoostManagerSliceMultiple: FC = () => {
  useEventbus({
    [EProfitBoostActions.CHECK_PROFIT_BOOST]: ({
      payload
    }: {
      payload: TCheckProfitBoostPayload;
    }) => {
      checkMultipleProfitBoostActionHandler(payload.data);
    }
  });

  return null;
};
